import React from 'react';
import DisplayConfiguration from './DisplayConfiguration';
import { pickDataAttributes } from '../../../Util';

const styles = Object.freeze([{},{}]);

const Display360Flex = (props) => {
  const dataAttributes = pickDataAttributes(props, 'display-360-flex');

  return <DisplayConfiguration {...props} styles={styles} {...dataAttributes} className="display-360-flex" />;
}

export default Display360Flex;
